define('PLPStockAvailability.View',
	[
	'SCView',
	'plpstockavailability.tpl',	
	'Backbone',
	'jQuery',
	'underscore'
    ],
	 function PLPStockAvailabilityView(
	SCViewComponent,
	plpstockavailability_tpl,
	Backbone,
	jQuery,
	_
)
{
    'use strict';

	var SCView = SCViewComponent.SCView;

	function PLPStockAvailabilityView(options) {
		SCView.call(this,options);

		this.options = options || {};
		this.container = options.container;
		this.quantity;

		this.template = plpstockavailability_tpl;

		this.contextDataRequest = ['item'];
	}

	// Inherit parent instance methods.
	PLPStockAvailabilityView.prototype = Object.create(SCView.prototype);

	// Restore the constuctor.
	PLPStockAvailabilityView.prototype.constructor = PLPStockAvailabilityView;

	// NOTE: This must be assigned AFTER Object.create() above, otherwise it is
	// clobbered (dead) when the prototype is replaced.
	PLPStockAvailabilityView.prototype.contextDataRequest = ['item'];

	PLPStockAvailabilityView.prototype.getContext = function() {
		// Rehydration guard: on the SEO-prerender attach path getContext() can be
		// called before contextData.item is populated. Bail out safely instead of
		// throwing (which would collapse the whole PLP view tree).
		var item = (this.contextData && typeof this.contextData.item === 'function')
			? this.contextData.item()
			: null;

		if (!item) {
			return {};
		}

		let customStatus;
		if(item.custitem_stocking_status === 'Special Order' || item.custitem_stocking_status === 'Zip Ship') {
			customStatus = item.custitem_stocking_status;
		} else {
			customStatus = null;
		}

		var context = {
			quantity: (item.quantityavailable || 0).toLocaleString('en-US'),
			quantityGreaterThanZero: (item.quantityavailable > 0),
			customStockingStatus: customStatus,
		}

		// Rehydration fix: confirmed empirically that on the attach path, this.el is a
		// detached Backbone-created element (isConnected: false) - it is NOT the real,
		// visible <div data-view="StockDescription"> placeholder already sitting in the
		// prerendered page, so writing into this.el never reaches the screen. The real
		// placeholder for this specific product cell is identified by data-item-id
		// (confirmed the value matches item.internalid exactly), but querying for it
		// synchronously here found zero matches - getContext() appears to run before
		// the browser has finished parsing this cell's markup into the live DOM.
		// Deferring the query/write to document-ready lets it run once parsing has
		// actually completed. Harmless on the classic path - the framework's own
		// render cycle overwrites this with the same content moments later regardless.
		if (item.internalid) {
			var internalId = item.internalid;
			jQuery(function () {
				jQuery('[data-item-id="' + internalId + '"]')
					.find('[data-view="StockDescription"]')
					.first()
					.html(plpstockavailability_tpl(context));
			});
		}

		return context;
	}

	PLPStockAvailabilityView.prototype.validateContextDataRequest = function() {
		// Reverted to unconditional true: gating this on contextData.item()
		// availability broke rendering on the classic (non-rehydration) path too,
		// confirmed empirically in the sandbox alongside the identical issue in
		// PLPBrandName - item context is evidently not guaranteed ready by the time
		// this is evaluated even on a normal load. Crash-safety is still handled by
		// the null guard in getContext() above; the rehydration blank/blurred state
		// remains an open issue pending further investigation into SC's real
		// per-item child view lifecycle.
		return true;
	}

	// Return the AMD constructor.
	return PLPStockAvailabilityView;

});
